export const DetailsCardMenu = [
  "Overview",
  "Market Depth",
  "About",
  "Fundamental",
  "Technical",
  "Income Statement",
  "Balance Sheet",
];

export const WatchListMenu = ["Custom", "Shariah", "Future", "Sector", "ETF"];

export const LogsMenu = [
  "Outstanding Log",
  "Trading Log",
  "Activity Log",
  "Consolidated Outstanding Log",
  "Consolidated Trading Log",
];